import React from 'react';
import Heading from '@atlaskit/heading';
import PanelErrorIcon from '@atlaskit/icon-lab/core/cross-octagon';
import PanelWarnIcon from '@atlaskit/icon-lab/core/vulnerability';
import PanelNoteIcon from '@atlaskit/icon/core/feed';
import TableIcon from '@atlaskit/icon/core/spreadsheet';
import PanelInfoIcon from '@atlaskit/icon/glyph/editor/panel';
import PresenceActiveIcon from '@atlaskit/icon/glyph/presence-active';
import { Box, Pressable, Stack, Text, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
var titleStyles = xcss({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 'space.100'
});
var iconStyles = xcss({
  borderWidth: 'border.width.outline',
  cursor: 'pointer'
});
var headingStyles = xcss({
  flex: 1
});
var pressableStyles = xcss({
  color: 'color.text.subtle',
  fontWeight: "var(--ds-font-weight-medium, 500)",
  padding: 'space.0',
  backgroundColor: 'color.background.neutral.subtle',
  ':hover': {
    textDecoration: 'underline'
  },
  ':active': {
    color: 'color.text'
  }
});
var containerStyles = xcss({
  display: 'flex',
  paddingInline: 'space.100',
  paddingBlock: 'space.200',
  flexDirection: 'column',
  gap: 'space.050',
  alignSelf: 'stretch',
  ':hover': {
    backgroundColor: 'elevation.surface.hovered'
  }
});
var defaultDetails = {
  icon: PresenceActiveIcon,
  message: 'Suggestion',
  description: 'A suggestion to improve the content.'
};
var detailsByConversionType = {
  CONVERT_TO_TABLE: {
    icon: TableIcon,
    message: 'Convert to a table',
    description: 'Convert the selected content to a table.'
  },
  CONVERT_TO_NOTE_PANEL: {
    icon: PanelNoteIcon,
    message: 'Convert to a note panel',
    description: 'Convert the selected content to a note panel.'
  },
  CONVERT_TO_INFO_PANEL: {
    icon: PanelInfoIcon,
    message: 'Convert to a info panel',
    description: 'Convert the selected content to an info panel.'
  },
  CONVERT_TO_WARN_PANEL: {
    icon: PanelWarnIcon,
    message: 'Convert to a warn panel',
    description: 'Convert the selected content to a warn panel.'
  },
  CONVERT_TO_ERROR_PANEL: {
    icon: PanelErrorIcon,
    message: 'Convert to an error panel',
    description: 'Convert the selected content to an error panel.'
  }
};
export var RecommendationItem = function RecommendationItem(props) {
  var _detailsByConversionT;
  var action = props.action;
  var _ref = (_detailsByConversionT = detailsByConversionType[action]) !== null && _detailsByConversionT !== void 0 ? _detailsByConversionT : defaultDetails,
    Icon = _ref.icon,
    description = _ref.description,
    message = _ref.message;
  return /*#__PURE__*/React.createElement(Stack, {
    xcss: containerStyles
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: titleStyles
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: iconStyles
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: message,
    position: "top"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "medium",
    label: message
  }))), /*#__PURE__*/React.createElement(Box, {
    xcss: headingStyles
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "xsmall"
  }, message)), /*#__PURE__*/React.createElement(PresenceActiveIcon, {
    size: "small",
    label: "unread",
    primaryColor: "var(--ds-icon-information, #1D7AFC)"
  })), /*#__PURE__*/React.createElement(Text, null, description), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Pressable, {
    xcss: pressableStyles,
    onClick: props.onApply
  }, "Apply"), ' ', "\xB7", ' ', /*#__PURE__*/React.createElement(Pressable, {
    xcss: pressableStyles,
    onClick: props.onDismiss
  }, "Dismiss")));
};